(function () {

    'use strict';

    angular.module('iplusjs.filter.numberString', [
        'iplusjs.utils.misc',
        'iplusjs.utils.format'
    ])
    .filter('numberString', NumberString);

    NumberString.$inject = [
        'FormatUtilsService',
        'MiscUtilsService'
    ];
    function NumberString(FormatUtilsService, MiscUtilsService) {
        return function (number, decimal, format) {
            var options = {};

            if (MiscUtilsService.isEmpty(number)) {
                return '';
            }

            options.decimal = decimal;
            options.format = format;

            return FormatUtilsService.formatNumber(number, options);
        };
    }
})();
